import React from 'react'
import DriverLayout from '../../layouts/DriverLayout'
import EmergencyContact from '../../components/EmergencyContact'

const DriverEmergency = () => {
  return (
    <DriverLayout>
    <EmergencyContact />
    </DriverLayout>
  )
}

export default DriverEmergency
